import {
  ADD_DWELLING,
  GET_DWELLING,
  GET_DWELLING_SERVICES,
  GET_DWELLING_SERVICES_INVENTORY,
  GET_DWELLINGS,
  REMOVE_DWELLING_FILE,
  UPDATE_DWELLING,
  UPLOAD_DWELLING_FILES,
} from "../constants";
import { IDwelling } from "../reducers";

export function addDwelling(dwelling: IDwelling, resolve: any, reject: any) {
  return {
    type: ADD_DWELLING,
    dwelling,
    resolve,
    reject,
  };
}

export function getDwelling(resolve: any, reject: any, id: string) {
  return {
    type: GET_DWELLING,
    resolve,
    reject,
    id,
  };
}

export function getDwellings(
  resolve: any,
  reject: any,
  page: number,
  filter: string,
) {
  return {
    type: GET_DWELLINGS,
    resolve,
    reject,
    page,
    filter,
  };
}

export function updateDwelling(dwelling: IDwelling, resolve: any, reject: any) {
  return {
    type: UPDATE_DWELLING,
    dwelling,
    resolve,
    reject,
  };
}

export function getDwellingServices(
  resolve: any,
  reject: any,
  page: number,
  dwellingId: string,
) {
  return {
    type: GET_DWELLING_SERVICES,
    resolve,
    reject,
    page,
    dwellingId,
  };
}

export function getDwellingServicesInventory(
  resolve: any,
  reject: any,
  page: number,
  dwellingId: string,
  types?: string[],
) {
  return {
    type: GET_DWELLING_SERVICES_INVENTORY,
    resolve,
    reject,
    page,
    dwellingId,
    types,
  };
}

export function uploadDwellingFiles(
  resolve: any,
  reject: any,
  id: string,
  files: any[],
) {
  return {
    type: UPLOAD_DWELLING_FILES,
    resolve,
    reject,
    id,
    files,
  };
}

export function removeDwellingFile(
  resolve: any,
  reject: any,
  dwellingId: string,
  fileId: string,
) {
  return {
    type: REMOVE_DWELLING_FILE,
    resolve,
    reject,
    dwellingId,
    fileId,
  };
}
